import { Box, Center, Flex, Image, Spacer, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

/**
 * empty section component
 * @constructor
 */
export const EmptySection = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Box bgColor={"#FBFCFF"} w={"100%"} h={`100%`}>
      <Center h={"100%"} w={"100%"}>
        <Flex
          direction="column"
          bgColor={"white"}
          borderRadius={"10px"}
          h={"304px"}
          w={"512px"}
          border={'1px solid #D3D7E2'}
          p={37}
        >
          <Text color={"#8E9ABC"} fontSize={"11px"}>
          <b>Doenba Edit</b> is a comprehensive AI-powered editing platform designed to streamline your writing process. <br /><br />
Work within an organized interface with a word-processor-style experience, featuring automatic LaTeX conversion—no coding required—and an intuitive graphical interface for managing cross-references and citations. Enjoy one-click export to various LaTeX templates for download and PDF preview.<br /><br />
Take full advantage of LaTeX by writing your own snippets with real-time PDF previews. <br /><br />
Boost your productivity with suggested outlines, text polishing and rephrasing, content review, and exposition restructuring. <br /><br />
Leverage the built-in question-answering system for real-time assistance throughout the writing process.
          </Text>
          <Spacer/>
          <Flex>
            <Spacer/>
            <Text color={"#333333"} fontSize={"11px"} mt={3}>
              {t("editor-editormodel-noSectionTip2.1")}
            </Text>
            <Image
              w={"40px"}
              objectFit="cover"
              src="/static/editor/add-square.png"
            />
            <Text color={"#333333"} fontSize={"11px"} mt={3}>
              {t("editor-editormodel-noSectionTip2.2")}
            </Text>
            <Spacer/>
          </Flex>
          <Spacer/>

          <Box
            marginLeft={"100px"}
            w={"50%"}
            h={"50px"}
            onClick={() => navigate("/edit")}
            cursor={"pointer"}
          >
            <Image
              objectFit="cover"
              src={"/static/doenba-logo-blue.png"}
            />
          </Box>
          <Spacer/>
        </Flex>
      </Center>
    </Box>
  )
}